import React from 'react';
import './AvatarPopUp.styles.css';
import { NavLink } from 'react-router-dom';
import { Links, LinksVariants } from '../../UI/Links/Links.tsx';
import { Spinner, SpinnerVariants, UserName } from '../../UI';
import { useGetUserQuery } from '../../apis';
import { imageSrc } from '../../utils/imageUrl';

interface AvatarPopUpProps {
  userId: string;
  displayName?: string;
  userName?: string;
  imageUrl?: string;
}

export const AvatarPopUp: React.FC<AvatarPopUpProps> = (props) => {

  const { data: userData, isLoading } = useGetUserQuery(props.userId);

  const displayName = userData?.displayName;
  const imageUrl = userData?.profileImgUrl;
  const userId = userData?._id;
  const userName = userData?.userName;
  const followersCount = userData?.followers;
  const followingCount = userData?.following;
  const pinions = userData?.questions;

  const onClick = (e: React.MouseEvent) => e.stopPropagation();

  if (isLoading) {
    return <div className='avatar-card'>
      <div className='flex justify-center'>
        <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
      </div>
    </div>;
  }

  return (
    <div onClick={onClick} className='avatar-card'>
      <div className='flex pb-app-base'>
        <NavLink className='w-app-3xl' to={`/profile/${userId}`}>
          <img
            src={!imageUrl ? '/profile-man.png' : imageSrc(imageUrl, 'thumb')} alt=""
            className='bg-gray-200 rounded-full'
          />
        </NavLink>
        <div className='flex flex-col'>
          <div className='px-app-base'>
            <Links variant={LinksVariants.PRIMARY} to={`/profile/${userId}`}>
              {displayName}
            </Links>
          </div>
          <div className='text-app-gray'>
            <UserName userName={userName} />
          </div>
        </div>
      </div>
      <div className='avatar-moto'>
        <p >I love coding and digital Marketing...awlkdnakdnadnand andadandadwnawniandapdnapdnapdna ipdnapdnpandpandpandpa</p>
      </div>

      <div className='flex gap-app-base'>
        <Links variant={LinksVariants.PRIMARY} to={`/user-questions/${userId}`} className='border-b-app-s border-b-transparent hover:border-b-app-white'>
          <span className='text-app-lg2-avatar-card mr-app-xs align-text-bottom'>
            {pinions}
          </span>
          <span className='text-app-base-avatar-card text-app-gray align-text-bottom'>Pinions</span>
        </Links>
        <Links variant={LinksVariants.PRIMARY} to='#' className='border-b-app-s border-b-transparent hover:border-b-app-white'>
          <span className='text-app-lg2-avatar-card mr-app-xs align-text-bottom'>
            {followingCount}
          </span>
          <span className='text-app-base-avatar-card text-app-gray align-text-bottom'>Following</span>
        </Links>
        <Links variant={LinksVariants.PRIMARY} to='#' className='border-b-app-s border-b-transparent hover:border-b-app-white'>
          <span className='text-app-lg2-avatar-card mr-app-xs align-text-bottom'>
            {followersCount}
          </span>
          <span className='text-app-base-avatar-card text-app-gray align-text-bottom'>Followers</span>
        </Links>
      </div>
    </div>
  );
};
